export default {
  applyPadding: {},
  defaultStyle: {
    backgroundColor: '#f4f4f4',
    font: "300 13px 'Roboto', sans-serif",
    textAlign: 'left',
    '& $applyPadding': {
      padding: '21px 30px 17px',
      background: '#f4f4f4'
    }
  },
  hide: {
    display: 'none'
  },
  show: {
    display: 'block'
  },
  preference: {
    cursor: 'pointer',
    position: 'relative',
    background: '#fff',
    padding: '3px 0 3px 0',
    marginLeft: '3px',
    '&:lang(ar)':{
      marginLeft: "0",
      marginRight: "3px"
    }
  },
  selectContainer: {
    width: 'calc(25% - 40px / 4)',
    float: 'left',
    margin: '0 10px 10px 0',
    '&:nth-of-type(4n)': {
      marginRight: '0',
      '&:lang(ar)':{
        marginLeft: "0",
        marginRight: "10px"
      }
    },
    '&:lang(ar)':{
      float: "right",
      marginLeft: "10px",
      marginRight: "0"
    }
  },
  message: {
    MsBoxSizing: 'content-box',
    MozBoxSizing: 'content-box',
    WebkitBoxSizing: 'content-box',
    boxSizing: 'content-box',
    border: '0',
    color: 'inherit',
    margin: '0',
    padding: '0'
  },
  gray: {
    backgroundColor: '#f4f4f4'
  }
};
